import { LegalBlock } from "./legalDocument";
import "./legal-document.css";

interface LegalDocumentViewProps {
  blocks: LegalBlock[];
}

/** Renders the parsed blocks of a legal document. */
function LegalDocumentView({ blocks }: LegalDocumentViewProps) {
  return (
    <div className="legal-document">
      {blocks.map((block, index) => {
        switch (block.type) {
          case "documentTitle":
            return (
              <h3 key={index} className="legal-document-title">
                {block.text}
              </h3>
            );
          case "section":
            return (
              <h4 key={index} className="legal-document-section">
                {block.text}
              </h4>
            );
          case "subSection":
            return (
              <h5 key={index} className="legal-document-subsection">
                {block.text}
              </h5>
            );
          case "bullet":
            return (
              <p key={index} className="legal-document-bullet">
                {block.text}
              </p>
            );
          case "divider":
            return <hr key={index} className="legal-document-divider" />;
          default:
            return (
              <p key={index} className="legal-document-paragraph">
                {block.text}
              </p>
            );
        }
      })}
    </div>
  );
}

export default LegalDocumentView;
